import { Grid } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { SelectInput } from '../../../../components/selectInput/SelectInput';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import { CustomButton } from '../../../../components/customButton/CustomButton';
import { CustomDialog } from '../../../../components/customDialog/CustomDialog';

import './stepDietas.scss';
export const DietaDetalle = ({ open, onClose, onRowClick, onEditRowClick, rowData, elecciones }) => {

    const isNew = Boolean(!rowData.eleccion);

    const [eleccionSelected, setEleccionSelected] = useState(0);

    useEffect(() => {
        if (!isNew) {
            setEleccionSelected(rowData.eleccion);
        } else {
            setEleccionSelected(0)
        }
    }, [rowData])

    const handleChangeEleccion = (e) => {
        setEleccionSelected(e.target.value);
    }
    return (

        <CustomDialog
            open={open}
            maxWidth='xs'
            fullWidth={true}
            title={isNew ? 'Agregar elección' : 'Editar elección'}
            onCancel={onClose}
            cancelText='Cerrar'
            acceptText={isNew ? 'Agregar' : 'Guardar'}
            onAccept={() => isNew ? onRowClick({
                eleccion: eleccionSelected,
                idPlanCuidadoDieta: 0,
                id: 0,
                idPlanCuidado: 0
            }) : onEditRowClick({
                eleccion: eleccionSelected,
                idPlanCuidadoDieta: rowData?.idPlanCuidadoDieta,
                id: rowData?.id,
                idPlanCuidado: 0
            }
            )}
        >
            <div className='container-modal-dieta'>
                <Grid
                    container
                    columns={{
                        xs: 1,
                        md: 1
                    }}
                    className='plan-cuidado-dietas-grid-row'
                    spacing={2}
                >
                    <Grid size={{ xs: 1 }}>
                        <SelectInput options={elecciones}
                            label='Elección'
                            onChange={(e) => handleChangeEleccion(e)}
                            name='idPrograma'
                            value={eleccionSelected}
                        />
                    </Grid>
                </Grid>
            </div>
        </CustomDialog>
    )
}